module.exports = __webpack_public_path__ + "img/drag.ee58f496.svg";